<ng-container *ngIf="!datosRecibidos && errorMessage === ''">
    <div class="wait-top-container">
        <div class="wait-container">
            <span class="wait-message">Cargando datos...</span>
            <mat-progress-bar mode="indeterminate" class="progress-bar" color="warn"></mat-progress-bar>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="errorMessage !== ''">
    <div class="wait-top-container">
        <div class="wait-container">
            <div class="wait-message">{{ errorMessage }}</div>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="errorMessage === '' && datosRecibidos">
    <div class="table-header">
        <div class="header-content">
            <span>LISTADO DE ESTABLECIMIENTOS</span>
            <button mat-icon-button [matMenuTriggerFor]="menu" class="more-vert-btn">
                <mat-icon>more_vert</mat-icon>
            </button>
        </div>
        <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="descargarExcel()">
                <mat-icon>download</mat-icon>
                <span>Exportar a Excel</span>
            </button>
        </mat-menu>
    </div>

    <div class="mat-elevation-z8">
        <div class="top-container">
            <mat-form-field>
                <mat-label class="negro">Filtrar</mat-label>
                <mat-icon matPrefix>search</mat-icon>
                <input matInput (keyup)="applyFilter($event)" placeholder="Ex.nombre" #input>
            </mat-form-field>
        </div>

        <table mat-table [dataSource]="dataSource" matSort>

            <ng-container matColumnDef="external_id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> ID </th>
                <td mat-cell *matCellDef="let element" class="est-nombre"> {{element.external_id}} </td>
            </ng-container>

            <ng-container matColumnDef="est_name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Nombre </th>
                <td mat-cell *matCellDef="let element" class="est-nombre"> {{element.est_name}} </td>
            </ng-container>

            <!--<ng-container matColumnDef="est_beertypes">
                <th mat-header-cell *matHeaderCellDef mat-sort-header  class="centered-th" > Tipo Cerveza </th>
                <td mat-cell *matCellDef="let element" class="cell">
                    {{ getTypeLabel(element.est_beertypes[0], element.est_beertypes[1]) }}
                </td>
            </ng-container>-->

            <ng-container matColumnDef="razon_social"  *ngIf="userDataInfo.pro_id == 4">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Cliente </th>
                <td mat-cell *matCellDef="let element" class="cell"> {{ element.razon_social }} </td>
            </ng-container>

            <ng-container matColumnDef="created_at">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Fecha Alta </th>
                <td mat-cell *matCellDef="let element" class="cell"> {{ (element.created_at) }} </td>
            </ng-container>

            <ng-container matColumnDef="updated_at">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Modificado </th>
                <td mat-cell *matCellDef="let element" class="cell"> {{ (element.updated_at) }} </td>
            </ng-container>

            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Estado </th>
                <td mat-cell *matCellDef="let element" class="cell">
                  <ng-container *ngIf="element.status == 'Desactivado'; else activeStatus">
                    <span class="gris">Desactivado</span>
                  </ng-container>
                  <ng-template #activeStatus>
                    <span class="verde">Activado</span>
                  </ng-template>
                </td>
            </ng-container>

            <ng-container matColumnDef="nDevices">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Nº Dispositivos </th>
                <td mat-cell *matCellDef="let element" class="cell align-center "> {{element.nDevices}} </td>
            </ng-container>

            <ng-container matColumnDef="nTanks">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Nº Tanques </th>
                <td mat-cell *matCellDef="let element" class="cell align-center "> {{element.nTanks}} </td>
            </ng-container>

            <ng-container matColumnDef="operaciones">
                <th mat-header-cell *matHeaderCellDef> Operaciones </th>
                <td mat-cell *matCellDef="let element">
                  <div class="button-container">
                    <button mat-mini-fab class="ver-btn material-symbols-outlined" matTooltip="Monitorizar Establecimiento" aria-label="Monitorizar Establecimiento" routerLink="/establecimiento/ver/{{element.id}}">
                        <mat-icon>stacked_bar_chart</mat-icon>
                    </button>
                    <button mat-mini-fab class="ver-btn" matTooltip="Ver establecimiento" aria-label="Ver establecimiento" routerLink="/establecimiento/{{element.id}}">
                      <mat-icon>remove_red_eye</mat-icon>
                    </button>
                    <button *ngIf="userDataInfo.pro_id == 4 || userDataInfo.pro_id == 1" mat-mini-fab class="edit-btn" matTooltip="Editar establecimiento" 
                    aria-label="Editar establecimiento" routerLink="/{{element.id}}/editar/establecimiento">
                      <mat-icon>edit</mat-icon>
                    </button>
                    <!--<div *ngIf="userData.pro_id != 4" aria-label="None" class="cell">
                        <span>None</span>
                    </div>-->
                  </div>
                </td>
              </ng-container>
        
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <mat-paginator 
            [pageSizeOptions]="[10,25,50]" 
            showFirstLastButtons 
            aria-label="Elige una página"
            class="paginator">
        </mat-paginator>
    </div>
</ng-container>
